import { Link } from 'react-router-dom';
import { works } from '@/mocks/doujin';

export default function TodayUpdates() {
  const today = works.filter((w) => w.updateTime === '今日更新');

  return (
    <section id="today" className="px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <p className="flex items-center gap-2 text-accent-700 text-sm font-medium">
            <i className="ri-flashlight-fill"></i> TODAY
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">今日更新速递</h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">今日同人库今日更新汇总，最新汉化与连载进度一眼掌握</p>
        </div>
        <Link
          to="/updates"
          className="inline-flex items-center gap-1 text-primary-700 text-sm font-medium hover:text-primary-600 whitespace-nowrap"
        >
          查看全部更新 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {today.length > 0 && (
          <div className="lg:col-span-2 bg-background-100 rounded-lg overflow-hidden flex flex-col md:flex-row">
            <Link to={`/article/${today[0].slug}`} className="md:w-1/2 block overflow-hidden">
              <img
                src={today[0].cover}
                alt={`${today[0].title}封面`}
                className="w-full h-56 md:h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </Link>
            <div className="p-6 md:p-8 flex flex-col justify-center flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">今日头条</span>
                <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">{today[0].status}</span>
              </div>
              <h3 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
                <Link to={`/article/${today[0].slug}`} className="hover:text-primary-700 transition-colors">
                  {today[0].title}
                </Link>
              </h3>
              <p className="mt-3 text-foreground-600 text-sm leading-relaxed line-clamp-3">{today[0].summary}</p>
              <p className="mt-4 text-foreground-500 text-sm">
                最新章节：<span className="text-primary-700 font-medium">{today[0].latestChapter}</span>
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {today[0].tags.map((t) => (
                  <span key={t} className="px-2.5 py-1 rounded bg-background-50 text-foreground-600 text-xs">#{t}</span>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="bg-background-50 border border-background-200 rounded-lg p-5">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-heading text-base font-semibold text-foreground-950">今日追更排行</h3>
            <span className="text-xs text-foreground-400">按热度</span>
          </div>
          <ol className="space-y-3">
            {works
              .slice()
              .sort((a, b) => b.views - a.views)
              .slice(0, 6)
              .map((w, idx) => (
                <li key={w.slug}>
                  <Link
                    to={`/article/${w.slug}`}
                    className="flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors"
                  >
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-bold ${
                        idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground-800 truncate">{w.title}</p>
                      <p className="text-xs text-foreground-400 mt-0.5">{w.latestChapter}</p>
                    </div>
                    <span className="flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
                      <i className="ri-eye-line"></i>
                      {(w.views / 1000).toFixed(1)}k
                    </span>
                  </Link>
                </li>
              ))}
          </ol>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {today.slice(1).map((w) => (
          <article key={w.slug} className="bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-200 transition-colors">
            <Link to={`/article/${w.slug}`} className="block aspect-[16/9] overflow-hidden">
              <img
                src={w.cover}
                alt={`${w.title}封面`}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </Link>
            <div className="p-4">
              <h4 className="font-heading text-base font-semibold text-foreground-950 line-clamp-1">
                <Link to={`/article/${w.slug}`} className="hover:text-primary-700 transition-colors">{w.title}</Link>
              </h4>
              <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2">{w.summary}</p>
              <p className="mt-3 text-xs text-primary-700 font-medium">{w.latestChapter}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}